import { PerformedSearchRequestContext } from 'clientState/providers/SearchRequestProvider';
import ItemCollector from '../../../Filters/queries/ItemCollector';
import joinItems from '../../../Filters/queries/joinItems';
import { Location, SegmentFragment } from 'generated/graphql';

type ConnectionCollectorReturnType = {
  add: (segment: SegmentFragment) => void;
  build: () => Location[];
};
const ConnectionCollector = (): ConnectionCollectorReturnType => {
  const stopoverByLegCollector = ItemCollector<Location>();
  return {
    add({ sections }: SegmentFragment) {
      for (let index = 0; index < sections.length - 1; ++index) {
        stopoverByLegCollector.add(sections[index].destination);
        stopoverByLegCollector.add(sections[index + 1].departure);
      }
    },
    build() {
      return stopoverByLegCollector.build();
    },
  };
};

const ConnectionByLegCollector = (
  { tripType }: PerformedSearchRequestContext,
  isUnbundle = false
) => {
  const connectionsByLegCollectors: ConnectionCollectorReturnType[] = [];

  return {
    add(legIndex: number, segment: SegmentFragment) {
      connectionsByLegCollectors[legIndex] =
        connectionsByLegCollectors[legIndex] || ConnectionCollector();
      connectionsByLegCollectors[legIndex].add(segment);
    },
    build() {
      const connectionsByLeg = connectionsByLegCollectors.map((collector) =>
        collector.build()
      );
      if (tripType === 'ROUND_TRIP' && !isUnbundle) {
        return [joinItems([...connectionsByLeg[0], ...connectionsByLeg[1]])];
      }
      return connectionsByLeg;
    },
  };
};

export default ConnectionByLegCollector;
